<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>


<mat-card appearance="outlined" *ngIf="isLoaded">
  <mat-card-title>Infos</mat-card-title>
  <mat-list-item>ID: {{boundComposition._id}}</mat-list-item>
  <mat-list-item>gaTrackingId: {{boundComposition.gaTrackingId}}</mat-list-item>
  <mat-list-item>Location: {{boundComposition.location.coordinates[0]}} : {{boundComposition.location.coordinates[1]}}</mat-list-item>
  <mat-list-item>Languages: <span *ngFor="let lang of boundComposition.screen.availableLanguages">{{lang}} </span></mat-list-item>
</mat-card>

<page-content>
  <data-table
    (detail)="onDetail($event)"
    (edit)="onEdit($event)"
    (remove)="onRemove($event)"
    [columns]="columns"
    [dataProviderParams]="params"
    [dataProvider]="compositionAppService"
    [title]="'Apps'">
  </data-table>
</page-content>
